
module.exports = {
    sanity: {
      projectId: "pbt0a49i",
      dataset: "production",
      token: process.env.SANITY_TOKEN,
    }
  }
  